module.exports = __webpack_public_path__ + "static/media/SucceedingasaScreenwriter.4e546d64.png";